export const WINDOW_DATA = [
    {
        id: 'power-rank',
        title: 'Power Ranks',
    },
    {
        id: 'line-movement',
        title: 'Line Movement',
    },
    {
        id: 'percent',
        title: 'Ticket Percents',
    },
    {
        id: 'prediction',
        title: 'Prediction',
    },
    {
        id: 'injuries',
        title: 'Injury Report',
    },
    {
        id: 'rosters',
        title: 'Team Rosters',
    },
    {
        id: 'schedule',
        title: 'Schedule',
    },
    {
        id: 'key-factor',
        title: 'Key Factors',
    },
    {
        id: 'pitchers',
        title: 'Pitchers',
    },
    {
        id: 'totals',
        title: 'Total Data',
    },
];
